import Search from '@/pages/Search'

export default {
    path: '/search',
    name: 'Search',
    component: Search
}


// WEBPACK FOOTER //
// ./src/router/search.js